<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col cols="12" sm="9" md="7" lg="5" xl="5">
        <!-- <b-col md="8"> -->
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <!-- <strong class="h6">A's 3D Player</strong> -->
                <h1>A's 3D Player</h1>
                <p class="text-muted">IDとパスワードを入力してください。</p>
                <form @submit.prevent="onLoginButton()">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <input type="text" class="form-control" placeholder="IDを入力してください" v-model="username">
                  </b-input-group>
                </form>
                <form @submit.prevent="onLoginButton()">
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <input type="password" class="form-control" placeholder="パスワードを入力してください" v-model="password">
                  </b-input-group>
                </form>
                <p class="text-danger">{{ strLoginError}}</p>
                <b-row align-h="end">
                  <b-col cols="12" >
                    <b-button variant="primary" class="btn-block" @click="onLoginButton" type="submit">ログイン</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>トライアル版 お申込み</h2>
                  <p>お施主様に魅力的なプレゼン方法をしませんか？とても簡単な操作で、iPad/iPhoneを用いて夢のマイホームを共有しましょう。</p>
                  <b-button variant="primary" class="active mt-3" href="https://www.cpu-net.co.jp/cad/3dplayer/index.html">いますぐ3ヵ月無料体験</b-button>
                </div>
              </b-card-body>
            </b-card> -->
          </b-card-group>
          <div align="right">&copy; 2025 <a href="https://www.cpu-net.co.jp" target="_blank">CPU Inc.</a></div>
        </b-col>
      </b-row>
    </div>
    <loading v-show="isLoading" msg="ログイン中..."></loading>
  </div>
</template>

<script>
import Loading from '../../components/Loading'
import Store from '@/store'
import ApiAccess from '@/components/ApiAccess'

export default {
  mixins: [ ApiAccess ],
  components: {
    Loading
  },
  name: 'Login',
  data: () => {
    return {
      isLoading: false,
      strLoginError: '',
      username: '',
      password: ''
    }
  },
  created: function () {
    this.username = Store.state.companyid
  },
  methods: {
    async onLoginButton () {
      var vm = this
      if (this.username !== '' && this.password !== '') {
        var postData = {
          'companyid': this.username.trim().toUpperCase(),
          'pass': this.password.trim().toUpperCase(),
          'type': 'browser'
        }
        try {
          this.isLoading = true
          var loginData = await this.$_Api_Login(postData)
          this.isLoading = false
          if (loginData === undefined) {
            this.strLoginError = 'ライセンス情報がみつかりません'
          } else if (loginData.token !== undefined) {
            Store.commit('login', { t: loginData.token, c: this.username.trim().toUpperCase(), g: loginData.grade })
            vm.$router.push('/Home')
          } else {
            this.strLoginError = loginData
          }
        } catch (error) {
        }
      }
    }
  }
}
</script>

<style scoped>
a:link { color:#23527c; }
a:visited { color: #23527c; }
.container{
  color: #333333;
}
input {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/Login.vue